/** ChatStatusBar — "ASYNC CHAT" + status pills, shown only for async-mode assistants. */

import React from "react";
import { useTranslation } from "react-i18next";
import { Zap } from "lucide-react";

const STATUS_STYLES = {
  ready: { dot: "#10b981", classes: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  running: { dot: "#f59e0b", classes: "bg-amber-50 text-amber-700 border-amber-200" },
  waitingAuth: { dot: "#3b82f6", classes: "bg-blue-50 text-blue-700 border-blue-200" },
  ended: { dot: "#9ca3af", classes: "bg-gray-50 text-gray-600 border-gray-200" },
  error: { dot: "#ef4444", classes: "bg-red-50 text-red-700 border-red-200" },
};

const getStatusKind = (isLoading, executionStatus) => {
  if (isLoading) return "running";
  switch (executionStatus) {
    case "WAITING_FOR_AUTH":
      return "waitingAuth";
    case "ERROR":
      return "error";
    case "ENDED":
    case "ENDED_MAX_INTERACTIONS":
    case "FORCED_ENDED":
      return "ended";
    default:
      return "ready";
  }
};

const STATUS_LABEL_KEYS = {
  ready: "statusReady",
  running: "statusRunning",
  waitingAuth: "statusWaitingAuth",
  ended: "statusEnded",
  error: "statusError",
};

const ChatStatusBar = ({ isLoading, executionStatus }) => {
  const { t } = useTranslation();
  const statusKind = getStatusKind(isLoading, executionStatus);
  const statusStyle = STATUS_STYLES[statusKind];

  return (
    <div className="flex items-center justify-between px-4 pt-3 pb-2 shrink-0">
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-semibold uppercase tracking-wide rounded-full bg-teal-50 text-teal-700 border border-teal-200">
        <Zap size={12} className="shrink-0" />
        {t("asyncChatBadge")}
      </span>
      <span
        className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-semibold rounded-full border ${statusStyle.classes}`}
      >
        <span
          className="w-1.5 h-1.5 rounded-full shrink-0"
          style={{ backgroundColor: statusStyle.dot }}
        />
        {t(STATUS_LABEL_KEYS[statusKind])}
      </span>
    </div>
  );
};

export { ChatStatusBar };
export default ChatStatusBar;
